export const STYLE_OPTIONS = [
  "professional",
  "dating",
  "avatar3d",
] as const;

export type StyleOption = (typeof STYLE_OPTIONS)[number];

export const PHOTO_PACK_TIERS = ["pack_6", "pack_12", "pack_24"] as const;
export type PhotoPackTier = (typeof PHOTO_PACK_TIERS)[number];

export const PHOTO_PACK_CATALOG = {
  pack_6: { photos: 6, rounds: 1 },
  pack_12: { photos: 12, rounds: 2 },
  pack_24: { photos: 24, rounds: 4 },
} as const satisfies Record<PhotoPackTier, { photos: number; rounds: number }>;

export type ImageVariant = "preview" | "hd";
